export const PLATFORM_TYPES = {
  marketCloudShop: '101001', // 智鲤-营销云-用户
  smartercarp_cs: '101000', // 智鲤-会员平台-客服

  carpunion_cs: '201000', // 万鲤商联(老)-会员平台-客服
  carpunionMemberStore: '202000', // 3.0运营平台-万鲤
  pointsShop: '201001', // 万鲤商联(老)-积分商城-用户
  cashShop: '201002', // 万鲤商联(老)-现金商城-用户
  stageShop: '201003', // 万鲤商联(老)-分期商城-用户
  card: '201004', // 万鲤商联(老)-礼包卡券-用户

  carpdance_cs: '301000', // 妙鲤-平台客服 **
  carpdance: '302000', // 百鲤跃川-官网
  carpdance_user: '302001', // 妙鲤会员平台-用户

  carpdanceMemberStore: '402000', // 3.0运营平台-妙鲤

  member: '501000', // 3.0会员平台
  memberStore: '502000', // 3.0运营平台

  tmallDXB: '100010', // 天猫动销宝
  tmallFCT: '100011', // 天猫分采通
  aliZC: '100012', // 阿里资产
};

export const POSITIONS = {
  // 营销云商品详情
  goodsDetail: 1,
  // 营销云商城首页
  marketHome: 2,
  // 营销云智能名片
  businessCard: 3,
  // 百鲤跃川官网
  carpdanceOfficial: 4,
  // 妙鲤会员端
  carpdancePlatform: 5,
  // 万鲤商联会员端(老)
  carpunionPlatform: 6,
  // 3.0会员端
  member3Platform: 7,
  // 万鲤商联集采商城小程序
  carpunionPurchaseMarket: 8,
  // 天猫动销宝
  tmallDXB: 9,
  // 天猫分采通
  tmallFCT: 10,
};

export const RELATION_TYPES = {
  // 营销云
  market: 0,
  // 站点
  site: 1,
  // 卡券
  coupons: 2,
  // 妙鲤平台
  carpdancePlatform: 3,
  // 百鲤跃川官网
  carpdanceOfficial: 4,
  // 万里商联会员(老)
  carpunionPlatform: 5,
  // 3.0会员端
  member3Platform: 6,
  // 集采小程序商城
  carpunionPurchaseMarket: 7,
  // 天猫动销宝
  tmallDXB: 8,
  // 天猫分采通
  tmallFCT: 9,
};
